// app/api.js
import axios from "axios";
import store from "./store";
import { logout } from "../features/auth/authSlice";
import {uuidv4} from "./utils";

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
});

axios.interceptors.request.use(
    (req) => {
        req.headers.common["X-Request-ID"] = uuidv4();
        return req;
    },
    (err) => {
        return Promise.reject(err);
    }
);

// Response interceptor
api.interceptors.response.use(
    (res) => res,
    (error) => {
        if (error.response?.status === 401) {
            localStorage.removeItem("clientToken");
            localStorage.removeItem("clientUser");
            store.dispatch(logout());
            window.location.href = "/login";
        }
        return Promise.reject(error);
    }
);

export default api;